import { render } from "./RequestHistoryModal.vue?vue&type=template&id=6e4ed4ef&scoped=true"
import script from "./RequestHistoryModal.vue?vue&type=script&lang=js"
export * from "./RequestHistoryModal.vue?vue&type=script&lang=js"

import "./RequestHistoryModal.vue?vue&type=style&index=0&id=6e4ed4ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4ed4ef"]])

export default __exports__